import React, { useEffect, useRef, useState } from "react";
import { DgaDigitalSignature, DgaIcon } from "platformscode-new-react";
import "./DigitalSignature.css";
const DigitalSignature = ({
  className = "",

}) => {
  const [isOpen, setIsOpen] = useState(false);


  return (
    <>

      <div className="bg-[#f5f5f5]">
        <div className={` container-padding hmm__wrapper${isOpen ? "" : " close"}`}>
          <div className="hmm__container hmm__heads">
            {/* Header */}
            <div className="hmm__icon-container">
              <img
                src="/assets2/imges/Country Flags.svg"
                alt="علم المملكة العربية السعودية"
                width={23}
                height={23}
                className="inline-block"
              />
            </div>

            <p>موقع حكومي مسجل لدى هيئة الحكومة الرقمية</p>

            <a
              href="#"
              className="hmm__link hmm__toggle-link link--md link--primary link--inline"
              onClick={(e) => {
                e.preventDefault();
                setIsOpen((prev) => !prev);
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  setIsOpen((prev) => !prev);
                }
              }}
              tabIndex={0}
            >
              كيف تتحقق

              <div className="hmm__link-icon">
                <img
                  src="/assets2/imges/arrow-down-01.svg"
                  alt="سهم لأسفل"
                  width={20}
                  height={20}
                  className="inline-block"
                  style={{
                    transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                    transition: 'transform 0.3s ease',
                  }}
                />
              </div>
            </a>
          </div>

          {/* Content */}
          <div className={`hmm__collapsible ${isOpen ? "open" : ""}`}>
            <div className="min-h-0">
              <div className="hmm__content">
                <div className="hmm__content-container">
                  {/* Item 1 */}
                  <div className="hmm__content-item">
                    <div className="hmm__content-item-icon" style={{ padding: "0px" }}>
                      <img
                        src="/assets2/imges/link-04.svg"
                        alt="أيقونة رابط"
                        width={20}
                        height={20}
                        className="inline-block"
                      />
                    </div>

                    <div className="hmm__content-item-content">
                      <h2>
                        روابط المواقع الالكترونية الرسمية السعودية تنتهي بـ
                        <span>&nbsp;.gov.sa</span>
                      </h2>
                      <p>
                        جميع روابط المواقع الرسمية التابعة للجهات الحكومية في
                        المملكة العربية السعودية تنتهي بـ .gov.sa
                      </p>
                    </div>
                  </div>

                  {/* Item 2 */}
                  <div className="hmm__content-item">
                    <div className="hmm__content-item-icon" style={{ padding: "0px" }}>
                      <img
                        src="/assets2/imges/square-lock-password.svg"
                        alt="أيقونة القفل"
                        width={20}
                        height={20}
                        className="inline-block"
                      />
                    </div>

                    <div className="hmm__content-item-content">
                      <h2>
                        المواقع الالكترونية الحكومية تستخدم بروتوكول
                        <span>&nbsp;HTTPS</span>&nbsp;للتشفير و الأمان.
                      </h2>
                      <p>
                        المواقع الالكترونية الآمنة في المملكة العربية السعودية
                        تستخدم بروتوكول HTTPS للتشفير.
                      </p>
                    </div>
                  </div>
                </div>

                {/* More Content */}

                <div className="flex flex-col md:flex-row md:justify-between  gap-[0px] md:gap-[18px]">
                  <div className="hmm__more-content w-full" >
                    <div className="hmm__more-content-icon">
                      <div className="hmm__content-item-icon">
                        <img
                          src="/assets2/imges/DGA logo.svg"
                          alt="شعار هيئة الحكومة الرقمية"
                          width={20}
                          height={20}
                          className="inline-block"
                        />
                      </div>
                    </div>

                    <div className="hmm__more-content-content">
                      <p>مسجل لدى هيئة الحكومة الرقمية برقم:</p>

                      <a
                        href="https://raqmi.dga.gov.sa/platforms/platforms/540af09e-306c-4a0d-f5a1-08dd7f8064c9/platform-license"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="hmm__link link--md link--primary link--inline"
                        aria-label="20250429196 - يفتح في نافذة جديدة"
                        style={{ display: "inline-flex", alignItems: "center", gap: "4px" }}
                      >
                        <span className="hmm__link">20250429196</span>
                         <DgaIcon
                          icon="link-square-02"
                          size={14}
                          variant="stroke"
                          type="standard"
                          aria-hidden="true"
                        />
                      </a>
                    </div>
                  </div>


                  <div className="hmm__more-content w-full">
                    <div className="hmm__more-content-icon">
                      <div className="hmm__content-item-icon">
                        <img
                          src="/assets2/imges/DGA logo.svg"
                          alt="شعار هيئة الحكومة الرقمية"
                          width={20}
                          height={20}
                          className="inline-block"
                        />
                      </div>
                    </div>

                    <div className="hmm__more-content-content">
                      <p>  حاصل على شهادة الجودة من هيئة الحكومة الرقمية </p>

                      <a
                        href="https://hmm.gov.sa/HMM_Q_Cert.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="DS00010 - يفتح في نافذة جديدة"
                        className="hmm__link link--md link--primary link--inline"
                        style={{ display: "inline-flex", alignItems: "center", gap: "4px" }}
                      >
                        <span>DS00010</span>
                        <DgaIcon
                          icon="link-square-02"
                          size={14}
                          variant="stroke"
                          type="standard"
                          aria-hidden="true"
                        />
                      </a>
                    </div>
                  </div>

                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DigitalSignature;